import React, {useEffect, useState} from "react";
import { Route, Routes } from "react-router";
import Homepage from "./pages/homepage";
import {useTranslation} from "react-i18next";
import Loading from "../components/common/loading";
import API from "../lib/apiUtils"; // adjust the path as needed
import PrivacyPolicy from "./pages/privacy-policy";
import CookiePolicy from "./pages/cookie-policy";
import RegistrazioneAnagrafica from "./pages/registrazione-anagrafica";

function SiteRoutes() {
    const { i18n } = useTranslation();
    let language = i18n.language.includes('en') ? 'en' : 'it';

    const [siteConfig, setSiteConfig] = useState(null);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
      function getConfigData() {
        setLoading(true);
        setSiteConfig(null);
        API.get(`/settings?lang=${language}`)
          .then((data) => {
            setSiteConfig(data);
            setLoading(false);
          })
          .catch((err) => {
            console.error("Error fetching settings:", err);
            setLoading(false);
          });
      }

      getConfigData();
    }, [language]);

    if(isLoading){
        return (<><Loading /></>);
    }

    return (
        <Routes>
            <Route path="/" element={<Homepage siteConfig={siteConfig} language={language} />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy siteConfig={siteConfig} />} language={language} />
            <Route path="/cookie-policy" element={<CookiePolicy siteConfig={siteConfig} />} language={language} />
        </Routes>
    );
}

function Main() {
    return (
        <Routes>
            <Route path="/registrazione-anagrafica" element={<RegistrazioneAnagrafica />} />
            <Route path="/*" element={<SiteRoutes />} />
        </Routes>
    );
}

export default Main;
